/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CallToolRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'
import {CallToolResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'


export const callTool = (request: CallToolRequest, options?: CashRequestOptions) => post<CallToolRequest, CallToolResponse>("/2.0/cash/call-tool", request, {...options, rejectOnError: true })